var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import classNames from "classnames";
import { ButtonDropdown } from "reactstrap";
var DropDownButton = /** @class */ (function (_super) {
    __extends(DropDownButton, _super);
    function DropDownButton(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            _this.setState(function (prevState) { return ({ open: !prevState.open }); });
        };
        _this.state = {};
        return _this;
    }
    DropDownButton.prototype.render = function () {
        var props = this.props;
        return (React.createElement(ButtonDropdown, { isOpen: this.state.open, toggle: this.toggle },
            React.createElement("button", { className: classNames("btn dropdown-toggle", {
                    "btn-primary": !props.link,
                    "btn-link": props.link,
                    "p-0": props.link
                }), disabled: props.disabled, type: "button", onClick: this.toggle }, props.label),
            React.createElement("div", { className: classNames("dropdown-menu dropdown-menu-right-sm", { show: this.state.open }) }, props.children(this.toggle))));
    };
    return DropDownButton;
}(React.PureComponent));
export { DropDownButton };
//# sourceMappingURL=DropDownButton.js.map